import { render, staticRenderFns } from "./ProjectValuationExternalReportPage11.vue?vue&type=template&id=226b6d40&"
import script from "./ProjectValuationExternalReportPage11.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationExternalReportPage11.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports